export class BancoDados {
  constructor({ bancoDadosId, host, port, schema, user }) {
    this.bancoDadosId = bancoDadosId;
    this.host = host;
    this.port = port;
    this.schema = schema;
    this.user = user;
  }
}
